import moment from "moment";

class EpochMonthService {
    // Returns months since 1970
    static getTodayEpochMonth() {
        const nineteenSeventy = moment("1970-01-01");
        const today = moment();
        return today.diff(nineteenSeventy, 'months');
    }

    // Convert epoch month to MMM yy
    static epochMonthToMMMYY(epochMonth: number) {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.format("MMM, YY");
    }

    // Convert epoch month to MMM
    static epochMonthToMMM(epochMonth: number) {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.format("MMM");
    }

    // Convert epoch month to MMMM
    static epochMonthToMMMM(epochMonth: number) {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.format("MMMM");
    }


    // Convert epoch month to YYYYMM
    static epochMonthToYYYYMM(epochMonth: number) {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.format("YYYYMM");
    }

    // Convert epoch month to Date object
    static epochMonthToDate(epochMonth: number): Date {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.toDate();
    }

    // Convert Date object to epoch month
    static dateToEpochMonth(date: Date): number {
        const nineteenSeventy = moment("1970-01-01");
        const targetDate = moment(date);
        return targetDate.diff(nineteenSeventy, 'months');
    }

    // Convert Given Month, Year to Epoch Month
    // Month is 0-indexed (0 = January, 11 = December)
    static monthYearToEpochMonth(month: number, year: number) {
        if (!Number.isInteger(month) || month < 0 || month > 11) {
            console.error(`Invalid month value: ${month}`);
            return null;
        }
        if (!Number.isInteger(year)) {
            return null;
        }

        const nineteenSeventy = moment({ year: 1970, month: 0, day: 1 }).startOf("day");
        const givenDate = moment({ year, month, day: 1 }).startOf("day");

        // Keep epoch-month zero-based to match the rest of this service
        return givenDate.diff(nineteenSeventy, "months");
    }
}

export default EpochMonthService;